<div class="main-container">
    <div class="content-container">
        <h1 id="title">Hi <span class="name">{{ activeAccount }}</span>,</h1>
        <p id="welcome">
            Welcome to the Intervention Tracker!
        </p>

        <div class="button-container">
            <a [routerLink]="['/intervention-tracker']">
                <button id="report" mat-fab extended>
                    <mat-icon>bug_report</mat-icon>
                    Report Interventions
                </button>
            </a>
            <a id="learn_more" [routerLink]="['/help']">
                Learn more
                <span>
                    <mat-icon>
                        arrow_forward
                    </mat-icon>
                </span>
            </a>
        </div>
    </div>
    <div class="background"> 
    </div>
</div>
